import { OccupationType } from "@covertree/new-business-graphql";
import { string } from "yup";

export const occupationType = () =>
  string().oneOf(Object.values(OccupationType)).nullable().optional();
